export const STORE_TASK_DETAILS = 'STORE_TASK_DETAILS';

export const CLOSE_TASK_OVERLAY = 'CLOSE_TASK_OVERLAY';

export const CHECKLIST_CLOSED = 'CHECKLIST_CLOSED';
